<template>
  <div :class="{ flexWidth }" class="mb-3 d-flex justify-content-around position-relative">
    <label :for="id" class="mt-2">{{ label }}</label>
    <input
      :readonly="readonly"
      :id="id"
      class="form-control w-75"
      :class="{ 'is-invalid': help }"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :type="type"
    />
    <fa class="position-absolute inputIcon" :icon="['fas', icon]" />
    <!-- v-ifでもしhelpがあれば表示自体を可能にする -->
    <span v-if="help" class="invalid-feedback">{{ help }}</span>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    label: String,
    id: String,
    help: String,
    modelValue: String,
    type: String,
    readonly: Boolean,
    flexWidth: String,
    icon: String,
  },
};
</script>

<style scoped>
.inputIcon {
  right: 4rem;
  top: 25%;
}
</style>
